module.exports = __webpack_public_path__ + "img/competition.dc3a4fa2.png";